// extracted by mini-css-extract-plugin
export var animating = "_1x-3";
export var background = "_1x-6";
export var constrainHeight = "_1x-2";
export var dark = "_1x-4";
export var dropdown = "_1x-1";
export var leave = "_1x-5";
export var option = "_1x-7";
export var root = "_1x-0";